import {Component, EventEmitter, OnInit, Output} from '@angular/core';

import {Station} from '../../models/station';
import {StationService} from '../../services/station.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

/**
 * Modal dialog asking confirmation to user for station deleting
 */
@Component({
  selector: 'app-station-delete',
  templateUrl: './station-delete.component.html',
  styleUrls: ['./station-delete.component.css']
})
export class StationDeleteComponent implements OnInit {

  station: Station;

  @Output() onDeleteValidation = new EventEmitter<boolean>();

  constructor(private stationService: StationService,
              public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
  }

  onDeleteClick() {
    this.activeModal.close(null);
    this.stationService.delete(this.station).subscribe(b => {
      this.onDeleteValidation.emit(true);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/stations/station-delete/station-delete.component.ts